import { render, staticRenderFns } from "./view.vue?vue&type=template&id=7744772c&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=7744772c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744772c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7744772c')) {
      api.createRecord('7744772c', component.options)
    } else {
      api.reload('7744772c', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=7744772c&scoped=true&", function () {
      api.rerender('7744772c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/remoteGuidance/view.vue"
export default component.exports